import Shepherd from 'shepherd.js';

if($('.network.editor').length){
    
    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'network-editor-v2'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: 'Editing your Challenge',
        text: "Welcome to the Challenge editor. Using the editor, you can change the visual appearance of your Challenge. Any changes you make are automatically saved.",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Pre-Selected Banner Image',
        text: "This banner image has been selected from a pool of images based on the sector you choose when creating your Challenge. We'll show you how to change it in the next step.",
        attachTo: {
            element: '.network-banner-image',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1-5'
    });
    
    tour.addStep({
        title: 'Changing Images and Text',
        text: "To change the images or text, click on the corresponding edit icon. This will open an image upload box or an input area for you to change text. For example, clicking this edit button will allow you to change the logo.",
        attachTo: {
            element: '.network-banner-image .upload-button',
            on: 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: 'Changing the Colour',
        text: "You can change the accent colour on your Challenge by clicking this button and either using the colour picker, or pasting in a hexadecimal colour code. The colour must be dark enough so that white text will be readable. We suggest using your brands' primary colour.",
        attachTo: {
            element: '.color-picker .input-wrapper',
            on: $(window).width() < 992 ? 'bottom' : 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    });
    
    if($('a.settings').length){
        tour.addStep({
            title: 'Changing your Settings',
            text: "If you're looking to amend the settings for your Challenge, such as the application deadline date, or whether or not you would like to have expert applications, clicking this button will take you to the settings page where you can amend these.",
            attachTo: {
                element: '.network-header-wrapper .settings',
                on: 'top'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-4'
        });
    }

    if($('.initial-network-setup').length){
        tour.addStep({
            title: 'What Next?',
            text: "Once you're happy with the changes you've made, take a look around the rest of your Challenge administration area using the sidebar navigation. We suggest you start with the reporting page.",
            attachTo: {
                element: '.continue-setup',
                on: 'top'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-5'
        });
    }else{
        tour.addStep({
            title: 'What next?',
            text: "Once you're happy with the changes you've take a look around the rest of your Challenges administration area using the sidebar navigation. We suggest you start with the reporting page.",
            attachTo: {
                element: '.dashboard--sidebar.network-administration-sidebar',
                on: 'right'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-6'
        });
    }

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if($('.network.editor').length && !$('.onboarding-network-editor-v2').length){
        tour.start();
    }
}
